import { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppContext from "../../../context";

import moment from 'moment';

import Meta from "../../components/Meta";
import Loading from "../../components/Loading";
import Header from "../../components/Header";
import Marketing from "../../components/Marketing";
import IssueReport from "../../components/IssueReport";

import Data from '../../../repository';

import styles from '../../../styles/Account.module.scss';
import DeleteAccount from "../../components/DeleteAccount";

function Account() {
	const context = useContext(AppContext);

	const [loading, setLoading] = useState(true);
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [minors, setMinors] = useState([]);
	const [transactions, setTransactions] = useState([]);
	const [transactionsLoading, setTransactionsLoading] = useState(false);

	useEffect(async () => {
		setFirstName(context.user.firstName);
		setLastName(context.user.lastName);
		setPhoneNumber(context.user.phoneNumber);
		setLoading(false);

		const minors = await Data.fetchMinors();
		setMinors(minors.data);
		loadTransactions();
	}, context.user);

	const loadTransactions = async () => {
		try {
			setTransactionsLoading(true);
			const result = await Data.fetchTransactions();
			setTransactions(result.data || []);
		} catch (error) {
			console.error('Failed to load transactions', error);
		} finally {
			setTransactionsLoading(false);
		}
	};

	const displayTransactions = transactions.filter((transaction) => !!transaction.Product);

	const updateUser = async (e) => {
		e.preventDefault();
		setLoading(true);

		await Data.updateUser({
			firstName,
			lastName,
			phoneNumber
		})

		await context.fetchUser();
		setLoading(false);
	}

	return (
		<>
			<Meta title="Settings" />

			<Header heading={"Settings"} />
			<main>

				<section>
					<form className={styles.form} onSubmit={updateUser}>
						<h2>Account Details</h2>
						<div>
							<p>Email Address:</p>
							<input type="text" value={context.user.email} disabled={true} />
						</div>

						<div>
							<p>First Name:</p>
							<input type="text" value={firstName} onChange={(e) => { setFirstName(e.target.value) }} disabled={loading} />
						</div>

						<div>
							<p>Last Name:</p>
							<input type="text" value={lastName} onChange={(e) => { setLastName(e.target.value) }} disabled={loading} />
						</div>

						<div>
							<p>Phone Number:</p>
							<input type="text" value={phoneNumber} onChange={(e) => { setPhoneNumber(e.target.value) }} disabled={loading} />
						</div>

						<div>
							<button className="btn btnPrimary" disabled={loading}>
								{loading ?
									<Loading button={true} />
									:
									`Update Details`
								}
							</button>
						</div>
					</form>
				</section>

				{context.domain.membershipMode || !context.domain.showMinorsForm ? null : <section>
						<div className={styles.minors}>
							<h2>Minors (Aged {context.domain.minorsAgeRange || "11 - 16"})</h2>
							<p>You can now bring your {context.domain.minorsAgeRange || "11 to 16"} year olds to the {context.domain.name}! Click the button below to add their details and complete the online waiver form.</p>

							{minors.map((minor) => {
								return (
									<div className={styles.minor}>
										<p><img src={require("../../../images/tick.svg").default} alt="Tick" /> {minor.name}</p>
										<p>Signed: {moment(minor.signed).format("Do MMM YYYY")}</p>
									</div>
								)
							})}

							<Link to="/dashboard/settings/add-minor">
								<a className="btn btnEmpty">+ Add Minor</a>
							</Link>
						</div>
					</section>
				}

				<section>
					{context.domain.walletEnabled ? (
						<div className={styles.purchases}>
							<h2>Wallet</h2>
							<div className={styles.purchaseItem}>
								<p>Current wallet balance</p>
								{context.domain.businessType === 'hybrid-new' ? (
									<p>{context.user.openGymBalance || 0} open gym tokens, {context.user.classBalance || 0} class tokens</p>
								) : context.domain.businessType === 'hybrid' ? (
									<p>{context.user.walletBalance || 0} tokens</p>
								) : (
									<p>£{((context.user.walletBalance || 0) / 100).toFixed(2)}</p>
								)}
								<Link to="/dashboard/wallet">Open Wallet</Link>
							</div>
						</div>
					) : null}
				</section>

				<section>
					<div className={styles.purchases}>
						<h2>Purchases</h2>
						{transactionsLoading ? (
							<p>Loading purchases...</p>
						) : (
							<>
								{!displayTransactions.length && <p>No purchases yet.</p>}
								{displayTransactions.map((transaction) => {
									const product = transaction.Product;
									const discount = transaction.DiscountCode;
									const label = product?.description?.trim()
										? `${product.description}${product.credits > 0 ? ` (${product.credits} ${product.credits > 1 ? "Tokens" : "Token"})` : ''}`
										: `${product.credits} ${product.credits > 1 ? "Tokens" : "Token"}`;
									const originalPrice = (product.price / 100).toFixed(2);
									const paidPrice = discount
										? ((product.price / 100) - (product.price / 100) * (discount.percentageOff / 100)).toFixed(2)
										: null;
									return (
										<div key={transaction._id} className={styles.purchaseItem}>
											<p>{label}</p>
											{paidPrice ?
												<p>£{paidPrice} <span style={{ textDecoration: 'line-through', color: '#999', marginLeft: '4px' }}>£{originalPrice}</span></p>
											:
												<p>£{originalPrice}</p>
											}
											<p>{moment(transaction.createdAt).format("Do MMM YYYY")}</p>
										</div>
									)
								})}
							</>
						)}
					</div>
				</section>

				<IssueReport />

				<Marketing />

				<DeleteAccount />

				<Link to="/log-out" className={styles.logout}>
					<a className="btn btnEmpty">Log Out</a>
				</Link>
			</main>
		</>
	);
}

export default Account;
